import { paths } from '@luxuryescapes/contract-svc-merchandise'
import requestUtils from 'api/requestUtils'
import qs from 'qs'

type Response = paths['/api/merchandise/suggestions']['get']['responses']['200']['content']['application/json']

function getMerchandiseSearchTypeahead(query: string): Promise<App.MerchandiseSearchTypeahead> {
  const queryString = qs.stringify({
    q: query,
  })

  return requestUtils.get<Response>(`/api/merchandise/suggestions?${queryString}`).then((response) => {
    return {
      categories: response.result.categories.map((category) => ({
        id: category.id,
        name: category.name,
      })),
      brands: response.result.brands.map((brand) => ({
        id: brand.id,
        name: brand.name,
      })),
      products: response.result.adverts.map((advert) => ({
        id: advert.id,
        name: advert.name,
      })),
    }
  })
}

export default getMerchandiseSearchTypeahead
